import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageManager: React.FC = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const currentLang = i18n.language;
    
    // Update the HTML lang attribute
    document.documentElement.lang = currentLang;
    
    // Update meta tags
    const metaLanguage = document.querySelector('meta[name="language"]');
    const metaContentLanguage = document.querySelector('meta[http-equiv="Content-Language"]');
    
    if (metaLanguage) {
      metaLanguage.setAttribute('content', currentLang);
    }
    
    if (metaContentLanguage) {
      metaContentLanguage.setAttribute('content', currentLang);
    }
  }, [i18n.language]);

  return null; // This component doesn't render anything
};

export default LanguageManager; 